export enum NotificationStatusEnum {
  Read = 'READ',
  Unread = 'UNREAD',
}

export interface Notification {
  id: string;
  userId: string;
  title: string;
  message: string;
  status: NotificationStatusEnum;
  metadata: Record<string, any>;
  createdAt: string;
}

export enum EndUserNotificationEventNameEnum {
  AcceptFollowRequest = "accept_follow_request",
  BlockEndUser = "block_end_user",
  BlockEndUserByOrg = "block_end_user_by_org",
  ChangeEmail = "change_email",
  CustomerAssetReport = "customer_asset_report",
  Following = "following",
  InviteAdmin = "invite_admin",
  InviteEndUser = "invite_end_user",
  GldInviteEndUser = "gld_invite_end_user",
  GldInviteExistingEndUser = "gld_invite_existing_end_user",
  GldAddedToCustomerFile = "gld_added_to_customer_file",
  GldCustomerIvdtCreated = "gld_customer_ivdt_created",
  GldReceivedCustomerFileRequest = "gld_received_customer_file_request",
  GldCancelledCustomerFileRequest = "gld_cancelled_customer_file_request",
  GldShareCustomerFileRequestHistory = "gld_share_customer_file_request_history",
  RecurringEmailReport = "recurring_email_report",
  ResetPassword = "reset_password",
  SendFollowRequest = "send_follow_request",
  ShareAsset = "share_asset",
  ShareEndUserDeepLink = "share_end_user_deep_link",
  ShareOrganizationDeepLink = "share_organization_deep_link",
  ShareIvdt = "share_ivdt",
  UnblockEndUser = "unblock_end_user",
  UnblockEndUserByOrg = "unblock_end_user_by_org",
  RemoveEndUser = "remove_end_user",
  VdtMinted = "vdt_minted",
  VerifyEmail = "verify_email",
  VerifyPhone = "verify_phone",
  MarketplaceEmail = "marketplace_email",
  ContactUs = "contact_us",
  SuspendOrder = "suspend_order",
  UnsuspendOrder = "unsuspend_order",
  BuyerBuyNow = "buyer_buy_now",
  SellerBuyerPaid = "seller_buyer_paid",
  BuyerOrderAccepted = "buyer_order_accepted",
  BuyerOrderShipped = "buyer_order_shipped",
  BuyerOrderDelivered = "buyer_order_delivered",
  BuyerVDTTransferred = "buyer_vdt_transferred",
  SellerOrderCancelled = "seller_order_cancelled",
  BuyerPaymentRefunded = "buyer_payment_refunded",
  SellerItemDelivered = "seller_item_delivered",
  SellerFundsTransferred = "seller_funds_transferred",
  SellerVDTTransferred = "seller_vdt_transferred",
  BuyerItemReceived = "buyer_item_received",
  SellerOrderAccepted = "seller_order_accepted",
  SellerOrderShipped = "seller_order_shipped",
  BuyerOrderCancelled = "buyer_order_cancelled",
  BuyerReturnDelivered = "buyer_return_delivered",
  SellerReturnDelivered = "seller_return_delivered",
  SellerOrderDelivered = "seller_order_delivered",
  SellerItemListed = "seller_item_listed",
  SellerFirstBid = "seller_first_bid",
  SellerAllBiddersRejected = "seller_all_bidders_rejected",
  SellerAuctionEnd = "seller_auction_end",
  SellerDelistAsset = "seller_delist_asset",
  SellerNewHighestBid = "seller_new_highestBid",
  BuyerNoLongerHighestBid = "buyer_no_longer_highest_bid",
  BuyerBidAccept = "buyer_bid_accept",
  BuyerTopFiveBidders = "buyer_top_five_bidders",
  BuyerAllOtherBidders = "buyer_all_other_bidders",
  BuyerBidRejected = "buyer_bid_rejected",
}

export interface EndUserNotificationEvent {
  name: EndUserNotificationEventNameEnum;
  description: string;
  isSms: boolean;
  isPush: boolean;
  isEmail: boolean;
}
